import { InputType } from "@repo/core/components/forms/InputTypeSelect/types";

export const dueDatesOptions: InputType[] = [
  {
    value: "1",
    label: "1"
  },
  {
    value: "5",
    label: "5"
  },
  {
    value: "11",
    label: "11"
  },
  {
    value: "15",
    label: "15"
  },
  {
    value: "21",
    label: "21"
  },
  {
    value: "25",
    label: "25"
  }
];

export enum ProposalTypeEnum {
  CREDIT = "1",
  FIDELITY = "2",
  CREDIT_FIDELITY = "3"
}

export enum SectionEnum {
  PROPOSALS = "proposals",
  IDENTIFICATION = "identification",
  PERSONAL_DATA = "personalData",
  ADDRESS = "address",
  PROFESSIONAL_DATA = "professionalData",
  REFERENCES = "references",
  PARAMETERS = "parameters"
}

export const proposalTypeOptions = {
  [ProposalTypeEnum.CREDIT]: "1",
  [ProposalTypeEnum.FIDELITY]: "2",
  [ProposalTypeEnum.CREDIT_FIDELITY]: "3"
};

export const viewSections = {
  [ProposalTypeEnum.CREDIT]: [
    SectionEnum.PROPOSALS,
    SectionEnum.IDENTIFICATION,
    SectionEnum.PERSONAL_DATA,
    SectionEnum.ADDRESS,
    SectionEnum.PROFESSIONAL_DATA,
    SectionEnum.REFERENCES,
    SectionEnum.PARAMETERS
  ],
  [ProposalTypeEnum.FIDELITY]: [
    SectionEnum.PROPOSALS,
    SectionEnum.IDENTIFICATION,
    SectionEnum.PERSONAL_DATA,
    SectionEnum.PROFESSIONAL_DATA,
    SectionEnum.PARAMETERS
  ],
  [ProposalTypeEnum.CREDIT_FIDELITY]: [
    SectionEnum.PROPOSALS,
    SectionEnum.IDENTIFICATION,
    SectionEnum.PERSONAL_DATA,
    SectionEnum.ADDRESS,
    SectionEnum.PROFESSIONAL_DATA,
    SectionEnum.REFERENCES,
    SectionEnum.PARAMETERS
  ]
};
